export const AUTH_LOGIN = 'AUTH_LOGIN';
export const AUTH_CHECK = 'AUTH_CHECK';
export const AUTH_BALANCE = 'AUTH_BALANCE';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_CHANGE_PASSWORD = 'AUTH_CHANGE_PASSWORD';
export const PAYMENTS = 'PAYMENTS';

export const GET_CLIENTS = 'GET_CLIENTS';
export const GET_SITES = 'GET_SITES';
export const GET_NEWS = 'GET_NEWS';
export const SET_PAGE = 'SET_PAGE';
export const SET_COUNT = 'SET_COUNT';
export const SET_TARIFFS = 'SET_TARIFFS';
export const SET_FILTER = 'SET_FILTER';
export const ADD_PURCHASES = 'ADD_PURCHASES';


export const SHOW_ERROR_MESSAGE = 'SHOW_ERROR_MESSAGE';
export const HIDE_ERROR_MESSAGE = 'HIDE_ERROR_MESSAGE';

export const SHOW_SUCCESS_MESSAGE = 'SHOW_SUCCESS_MESSAGE';
export const HIDE_SUCCESS_MESSAGE = 'HIDE_SUCCESS_MESSAGE';

